import { MVTLayer } from '@deck.gl/geo-layers'
import { type MVTLayerProps } from '@deck.gl/geo-layers/typed/mvt-layer/mvt-layer'

import { FeatureType } from 'stores/features'

class EnergyPlantLayer extends MVTLayer {
  public readonly type = FeatureType.EnergyPlant

  // the deck.gl typing are missing so we need this "useless" constructor for linting
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(props: MVTLayerProps) {
    super(props)
  }
}

EnergyPlantLayer.layerName = 'EnergyPlantLayer'
EnergyPlantLayer.defaultProps = {
  billboard: true,
  opacity: 1,
  parameters: {
    depthTest: false
  },
  getPixelOffset: [1, 2]
}
export default EnergyPlantLayer
